import React, { Component } from 'react';
import PageTitle from "../../Components/PageTitle";
import { ConfigContext } from "../../Context/ConfigContext";
import withRouter from '../../Utils/withRouter';
import Swal from 'sweetalert2';
import { GetCurrentMonthStartEndDates, IconButton, SubmitButton, TextBox, convertTo12HourFormat, formatDate, formatTime, getHoursAndMinutes, isNegativeDeviation } from '../../Components/InputElements'
import Select from 'react-select'
import axios from "axios";
import { NoRecords } from '../../Components/Shimmer';
import { currentDateAndTime, decodeData, formatDateToSQL, getFullYearMonthArray, getMonthCycleStartDate, getNextMonthIfDayExceeds20 } from '../../Constants/constants';
import * as XLSX from 'xlsx'


class MyAttendance extends Component {
    static contextType = ConfigContext;

    constructor(props) {
        super(props);
        this.state = {
            employee_attendance_id: 0,
            attendance_regularization_request_id: 0,
            employee_id: 0,
            position: [19.0742113, 72.8561198],
            loadingList: false,
            postLoading: false,
            loadingFilter: false,
            logs_data: [],
            leave_log_rows: [],
            punch_out_address: '',
            next: false,
            prev: false,
            rz_data: [],
            page: 1,
            limit: 10,
            modal_type: false,
            request_type: 0,
            total_records: 0,
            total_pages: 0,
            rows: [],
            employee_info: [],
            salaries: [],
            salaries_statutory: [],
            from_date: "",
            to_date: "",
            selectOption: "",
            month: null,
            monthOptions: [],
            punch_in_date: "",
            remark_by_employee: "",
            punch_in_time: "",
            punch_in_datetime: "",
            punch_out_datetime: "",
            punch_lat: "",
            punch_lng: "",
            punch_out_date: "",
            punch_out_time: "",
            attendance_date: "",
            display_name: "",
            city: "",
            company_location_shift_id: "",
            loadingLocation: false,
            showLocation: false,
            loadingMarkAttendance: false,
            shouldShowPunchInButton: false,
            shouldShowPunchOutButton: false,
            startDay: false,
            successMsg: false,
            errorMsg: false,
            decodedData: [],
            viewEmployeeVisitLogs: false,
            shouldShowExtraPunchButton: false,
            ExtraPunchInButton: false,
            ExtraPunchOutButton: false,
        };
        this.modalRef = React.createRef();
        this.closeRef = React.createRef();
        this.attendanceLocationInfoRef = React.createRef();
    }

    // componentDidMount() {
    //     this.setState({ loadingList: true }, () => {
    //         this.GetLocation();
    //         this.SetDates();
    //         this.GetRegularizationSettings();
    //         this.GetMonthFilterList();
    //         this.GetList();
    //     });
    //     //     let date = currentDateAndTime();
    //     //    let monthOpt = getFullYearMonthArray(date);
    //     //    console.log("this.state.monthOptions==>",this.state.monthOptions);
    //     //    this.setState({ monthOptions: monthOpt });
    // }

    async componentDidMount() {
        this.setState({ loadingList: true }, async () => {
            try {
                // await this.GetLocation();
                // await this.SetDates();
                await this.GetRegularizationSettings();
                await this.GetMonthFilterList();
                let date = getMonthCycleStartDate(currentDateAndTime(), this.state.startDay);
                let currMonth = getNextMonthIfDayExceeds20(date);
                // console.log("componentDidMount ~ currMonth",currMonth);
                this.setState({ month: currMonth });
                // await this.GetList();

            } catch (error) {
                console.error('An error occurred in component mounnting:', error);
            } finally {
                this.setState({ loadingList: false });
            }
        });
    }
    componentDidUpdate(prevProps, prevState) {
    if (prevState.permissions !== this.context.permissions) {
        // console.log("Permissions Updated:", this.context.permissions);
        const { permissions } = this.context;
        if (permissions.length > 0) {
            const queryParams = new URLSearchParams(window.location.search);
            const encodedData = queryParams.get("abs");
            // console.log("encodedData",encodedData);
            const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
            // console.log("decodedData",decodedData);
            if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
            this.setState({ decodedData });
            }
        } else {
            console.warn("Permissions not yet available. Retrying...");
        }
    }
    }


    GetMonthFilterList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Home/GetMonthYearFilterList`,
            {
                params: {
                    date: currentDateAndTime()
                }
                , headers
            }).then(async (response) => {
                const data = response.data;
                if (data?.success === true) {
                    // console.log("GetMonthYearFilterList data?.filterArray",data?.filterArray);
                    this.setState({
                        loadingList: false,
                        monthOptions: data?.filterArray
                    });

                    const currentMonth = Array.isArray(data?.filterArray) && data?.filterArray?.length>0 ? data?.filterArray[0]?.value : "";

                    this.setState({
                        month: currentMonth || null,
                        startDay: data?.month_cycle_start_date,
                    },()=>{ this.GetList(); 
                        // console.log("Month list 1 ===================================>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>"); 
                    });

                } else {
                    // this.GetList();
                    // console.log("Month list 2 ===================================>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
                    this.setState({ loadingList: false });
                }
            });
    };


    GetList = (fromWhereCalled) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        // console.log("GetAttendances ===================================>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
        // console.log("fromWhereCalled",fromWhereCalled);
        // console.log("GetAttendances ===================================>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
        axios.get(`${apiURL}Home/GetAttendances`,
            {
                params: {
                    limit: this.state.limit,
                    page: this.state.page,
                    attendance_status: this.state.selectOption || "",
                    from_date: this.state.from_date,
                    to_date: this.state.to_date,
                    month: this.state.month,
                    date: currentDateAndTime()
                }
                , headers
            }).then(async (response) => {
                var data = response.data;
                if (data?.response?.success === true) {
                    // console.log("data?.filterArray", data?.filterArray);
                    this.setState({
                        rows: data?.response?.data,
                        next: data?.response?.next,
                        prev: data?.response?.prev,
                        page: data?.response?.page,
                        total_records: data?.response?.total_records,
                        total_pages: data?.response?.total_pages,
                        loadingList: false,
                        loadingFilter: false,
                        shouldShowPunchInButton: data?.shouldShowPunchInButton,
                        shouldShowPunchOutButton: data?.shouldShowPunchOutButton,
                        shouldShowExtraPunchButton: data?.shouldShowExtraPunchButton,
                        ExtraPunchInButton: data?.ExtraPunchInButton,
                        ExtraPunchOutButton: data?.ExtraPunchOutButton,
                        //monthOptions: data?.filterArray
                    });

                }
                this.setState({ loadingList: false, loadingFilter: false });
            })
            .catch((error)=>{
                this.setState({ loadingList: false, loadingFilter: false });
                Swal.fire({ 
                title: `<strong>Failed</strong>`, 
                text: error?.message, 
                icon: 'error', 
                showConfirmButton: true,
                allowOutsideClick:false, 
                });
            });
    }
    scrollToDiv = () => {
        if (this.attendanceLocationInfoRef.current) {
            this.attendanceLocationInfoRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center',
            });
        }
    };
    getCurrentMonth = () => {
        const currentDate = currentDateAndTime()?.split(" ")[0]; // Extract the date part
        const currentMonth = currentDate?.split("-")[1]; // Get the month (second part)
        return currentMonth; // This should be a string representing the month (e.g., "09")
    };

    // handleCancelRegularization = (id) => {
    //     const { apiURL, apiHeaderJSON } = this.context;
    //     const headers = apiHeaderJSON;
    //     let date = currentDateAndTime();

    //     // Display Swal to get the remark before proceeding with the axios request
    //     Swal.fire({
    //         title: 'Enter remark',
    //         input: 'text',
    //         inputPlaceholder: 'Enter your remark here...',
    //         showCancelButton: true,
    //         inputAttributes: {
    //             'aria-label': 'Type your remark here'
    //         },
    //         confirmButtonText: 'Submit',
    //         cancelButtonText: 'Cancel',
    //         preConfirm: (value) => {
    //             if (!value) {
    //                 Swal.showValidationMessage('You need to write a remark!');
    //                 return false; // Prevent submission
    //             }
    //             return value; // Return the remark to be used
    //         }
    //     }).then((result) => {
    //         // Proceed with the axios call only if a remark was provided
    //         if (result.isConfirmed && result.value) {
    //             const formData = {
    //                 attendance_regularization_request_id: id,
    //                 remark: result.value, // Use the entered remark
    //             };

    //             // Make the axios request
    //             axios
    //                 .post(`${apiURL}Attendance/CancelRegularizationRequest`, formData, {
    //                     params: { date: date },
    //                     headers
    //                 })
    //                 .then((response) => {
    //                     Swal.fire({
    //                         title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
    //                         text: response.data.message,
    //                         icon: response.data.success === true ? 'success' : 'error',
    //                         timer: 1000,
    //                         timerProgressBar: true,
    //                         showConfirmButton: false,
    //                     });

    //                     // Refresh the logs if successful
    //                     if (response.data.success === true) {
    //                         this.GetRegularizationLogs();
    //                     }
    //                 })
    //                 .catch((error) => {
    //                     Swal.fire({
    //                         title: '<strong>Error</strong>',
    //                         html: error.message,
    //                         icon: 'error'
    //                     });
    //                 });
    //         }
    //     });
    // }

    handleExcelDownload = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        Swal.fire({
            title: 'Please wait...',
            html: 'Your file is being prepared for download.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        axios.get(`${apiURL}Home/GetAttendances`, {
            params: {
                limit: this.state.limit,
                page: this.state.page,
                attendance_status: this.state.selectOption || "",
                from_date: this.state.from_date,
                to_date: this.state.to_date,
                month: this.state.month,
                date: currentDateAndTime()
            }, headers
        }).then(async (response) => {
            // console.log("handleExcelDownload",response);
            if (response.data?.response?.success === true) {
                const rows = response.data?.response?.data;
                const data = rows.map(row => ({
                    'Date': formatDate(row.attendance_date),
                    'Punch In': `${row.PunchIn ? formatDate(row.PunchIn) : ""} - ${row.PunchIn ? formatTime(row.PunchIn) : "-"}`,
                    'Punch In Address': `${row.punch_in_address ? row.punch_in_address : row.PunchIn && !row.punch_in_address ? "Location is not captured." : "--"}`,
                    'Punch Out': `${row.PunchOut ? formatDate(row.PunchOut) : ""} - ${row.PunchOut ? formatTime(row.PunchOut) : "-"}`,
                    'Punch Out Address': `${row.punch_out_address ? row.punch_out_address : row.PunchOut && !row.punch_out_address ? "Location is not captured." : "--"}`,
                    'Shift': `${row.ShiftStart ? convertTo12HourFormat(row.ShiftStart) : ""} - ${row.ShiftEnd ? convertTo12HourFormat(row.ShiftEnd) : ""}`,
                    'Working Hours': row.WorkingHours ? getHoursAndMinutes(row.WorkingHours) : "- -",
                    // 'Deviation': row.Deviation ? getHoursAndMinutes(row.Deviation) : "- -",
                    'Attendance Status': row.employee_leave_id ? this.checkIsLeave(row) === " / 1" || this.checkIsLeave(row) === " / 2" ? this.calculateWorkingHours(row) ? "Half Day" : "Half Day Absent" : row.leave_type_name : row?.calendar_festivals_name ? "Holiday" : !row?.PunchIn && row?.ShiftWeekOff === "WeekOff" ? row?.ShiftWeekOff : row.AttendanceStatus,
                    // 'Action Status': row.regularizationRequestStatus ? row.regularizationRequestStatus : "- -",
                    // 'Regularization Type': row.regularizationType ? row.regularizationType : "- -",
                    // 'Reason': row.remark_by_employee ? row.remark_by_employee : "- -",
                    // 'Remark': row.remark_by_manager ? row.remark_by_manager : "- -",
                }));

                const columns = [
                    { header: 'Date', key: 'Date', width: 20 },
                    { header: 'Punch In', key: 'Punch In', width: 20 },
                    { header: 'Punch In Address', key: 'Punch In Address', width: 15 },
                    { header: 'Punch Out', key: 'Punch Out', width: 15 },
                    { header: 'Punch Out Address', key: 'Punch Out Address', width: 15 },
                    { header: 'Shift', key: 'Shift', width: 20 },
                    { header: 'Working Hours', key: 'Working Hours', width: 20 },
                    // { header: 'Deviation', key: 'Deviation', width: 20 },
                    { header: 'Attendance Status', key: 'Attendance Status', width: 20 },
                    // { header: 'Action Status', key: 'Action Status', width: 20 },
                    // { header: 'Regularization Type', key: 'Regularization Type', width: 20 },
                    // { header: 'Reason', key: 'Reason', width: 20 },
                    // { header: 'Remark', key: 'Remark', width: 20 },
                ];

                const wb = XLSX.utils.book_new();
                const ws = XLSX.utils.json_to_sheet(data, { header: columns.map(column => column.header) });
                ws['!cols'] = columns.map(column => ({ wch: column.width }));
                XLSX.utils.book_append_sheet(wb, ws, 'Attendance Report');
                const date = Array.isArray(rows) && rows?.length>0 ? `${formatDate(rows[0]?.attendance_date)?.split("-")[1]}-${formatDate(rows[0]?.attendance_date)?.split("-")[2]}`:"";
                XLSX.writeFile(wb, `Attendance Report ${date}.xlsx`);

                Swal.close();

                Swal.fire({
                    title: '<strong>Success</strong>',
                    html: 'Your file has been downloaded successfully.',
                    icon: 'success',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });
            } else {
                Swal.close();
                Swal.fire({
                    title: '<strong>Error</strong>',
                    html: response.data.message,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });
            }
        }).catch((error) => {
            Swal.close();
            Swal.fire({
                title: '<strong>Error</strong>',
                html: error.message,
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false,
            });
        });
    }

    // GetLocation = () => {
    //     this.setState({ loadingLocation: true });
    //     axios.get(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${this.state.position[0]}&lon=${this.state.position[1]}&zoom=18&addressdetails=1`).then((response) => {
    //         var data = response.data;
    //         if (response.data !== 0) {
    //             setTimeout(() => {
    //                 // Code to execute after 1 second
    //                 this.setState({
    //                     display_name: data.display_name,
    //                     city: data.address.city,
    //                     loadingLocation: false,
    //                 });
    //             }, 500);
    //         } else {
    //             this.setState({ loadingLocation: false });
    //         }
    //     });
    // }

    showInMap = (positionString, punch_in_date, punch_in_time, punch_in_address, show) => {
        if (!positionString) {
            return
        }
        const positionArray = positionString.split(',').map(Number);

        this.setState({
            position: positionArray,
            showLocation: show,
            punch_in_date: punch_in_date,
            punch_in_time: punch_in_time,
            punch_out_address: '',
            punch_in_address: punch_in_address,
            punch_out_date: null,
            punch_out_time: null,
        });
        // this.GetLocation();
    }

    showOutMap = (positionString, punch_out_date, punch_out_time, punch_out_address, show) => {
        if (!positionString) {
            return
        }
        const positionArray = positionString.split(',').map(Number);

        this.setState({
            position: positionArray,
            showLocation: show,
            punch_out_date: punch_out_date,
            punch_out_time: punch_out_time,
            punch_in_address: '',
            punch_out_address: punch_out_address,
            punch_in_date: null,
            punch_in_time: null,
        });
        // this.GetLocation();
    }

    handleInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };

    handleDateAndTime=(e)=>{
        const { name, value } = e.target;

        this.setState((prevState) => {
            const currentDateTime = prevState.punch_in_datetime || ""; // Use existing datetime or initialize
            const [currentDate, currentTime] = currentDateTime.split(" ");

            return {
                punch_in_datetime:
                    name === "punch_in_date"
                        ? `${value} ${currentTime || "00:00:00"}` // Update date, keep the time
                        : `${currentDate || "1970-01-01"} ${value}`, // Update time, keep the date
            };
        });
    }

    handleSelectChange(name, selectedOption) {
        this.setState((prevState) => ({
            [name]: selectedOption.value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    }

    handleInputSearch = () => {
        this.setState(
            {
                page: 1,
            },
            () => {
                this.GetList();
                // console.log("handleInputSearch ===================================>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
            }
        );
    }

    handleClearAll = () => {
        try {
            let filterArray = this.state.monthOptions;
            // console.log("filterArray in clear", filterArray);
            // Extract current month from your logic
            const currentMonth = parseInt(this.getCurrentMonth(), 10);

            // Find the corresponding month option based on the current month
            const defaultMonthOption = filterArray.find(option => parseInt(option.value.split("-")[0]) === currentMonth);
            this.setState(
                {
                    rows: [],
                    next: false,
                    prev: false,
                    page: 1,
                    limit: 10,
                    total_records: 0,
                    total_pages: 0,
                    loadingList: false,
                    postLoading: false,
                    from_date: "",
                    to_date: "",
                    selectOption: "",
                    // month: `${parseInt(currentDateAndTime()?.split(" ")[0]?.split("-")[1])}-${parseInt(currentDateAndTime()?.split(" ")[0]?.split("-")[0])}`,
                    // month: parseInt(currentDateAndTime()?.split(" ")[0]?.split("-")[1]),
                    month: defaultMonthOption ? defaultMonthOption.value : null,
                },
                () => {
                    this.GetList();
                    // console.log("handleClearAll ===================================>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");

                }
            );
        } catch (error) {
            this.setState({ loadingFilter: false });
        }
    };

    handlePrev = (ev) => {

        if (this.state.prev === true) {
            this.setState((prevState) => {
                return { page: prevState.page - 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleNext = () => {

        if (this.state.next === true) {
            this.setState((prevState) => {
                return { page: prevState.page + 1 };
            }, () => {
                this.GetList();
            });
        }
    }

    handleChange = (e) => {
        this.setState((prevState) => {
            return { page: parseInt(e.target.value, 10) };
        }, () => {
            this.GetList();
        });
    }

    handleRadioChange = (name, value) => {

        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));

    };

    GetLeaveLogs = (employee_leave_id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Home/GetLeaveLogs`, { params: { employee_leave_id: employee_leave_id }, headers }).then((response) => {
            var data = response.data;
            // this.setState({ leave_log_rows: [] });
            if (response.data.success === true) {
                this.setState({
                    leave_log_rows: data?.data,
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

    GetInfo = (row) => {
        // const { apiURL, apiHeaderJSON } = this.context;
        // const headers = apiHeaderJSON;
        // axios.get(`${apiURL}Attendance/GetAttendanceInfo`, {
        //     params: {
        //         employee_attendance_id: this.state.employee_attendance_id,
        //         employee_id: this.state.employee_id,
        //     }, headers
        // }).then((response) => {
        //     const { data, success } = response.data;
        //     if (success === true && data.length != 0) {

        //         const punchInDateTime = data[0].punch_in_datetime || this.state.punch_in_datetime;
        //         const punchOutDateTime = data[0].punch_out_datetime;

        //         let formattedPunchInDateTime = null;
        //         let formattedPunchOutDateTime = null;

        //         if (punchInDateTime != null && punchInDateTime) {
        //             formattedPunchInDateTime = this.formatGetedDateTime(punchInDateTime);
        //         }
        //         if (punchOutDateTime != null && punchOutDateTime) {
        //             formattedPunchOutDateTime = this.formatGetedDateTime(punchOutDateTime);
        //         }

        //         this.setState({
        //             punch_in_datetime: formattedPunchInDateTime,
        //             punch_out_datetime: formattedPunchOutDateTime,
        //         });
        //     } else {
        //         Swal.fire('Oops...?', 'Data Not Found', 'warning');
        //     }
        // });
        // punch_in_datetime: `${row?.attendance_date} ${row.ShiftStart}`,
        // punch_out_datetime: `${row?.attendance_date} ${row.ShiftEnd}`,
        // console.log("punch_in_datetime:", row.PunchIn || `${row?.attendance_date} ${row.ShiftStart}`,
        //  "punch_out_datetime:", row.PunchOut || `${row?.attendance_date} ${row.ShiftEnd}`);
        this.setState({
            employee_id: row.employee_id,
            employee_attendance_id: row.employee_attendance_id,
            attendance_regularization_request_id: row.attendance_regularization_request_id,
            attendance_date: row?.attendance_date,
            punch_in_datetime: row.PunchIn || `${row?.attendance_date} ${row.ShiftStart}`,
            punch_out_datetime: row.PunchOut || `${row?.attendance_date} ${row.ShiftEnd}`,
            modal_type: 1,
            request_type: 1,
        })
    }


    handleSubmit = (e) => {
        e.preventDefault();
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        // console.log("this.state.punch_in_datetime", this.state.punch_in_datetime, "this.state.punch_out_datetime", this.state.punch_out_datetime);
        const formatDateTime = (isoDateString) => {
            const date = isoDateString;
            const formattedDate = date.split("T")[0];
            const formattedTime = `${date.split("T")[1]}:00`;
            return `${formattedDate} ${formattedTime}`;
        };

        // Format punch_in_datetime and punch_out_datetime
        const formattedPunchInDateTime = formatDateToSQL(this.state.punch_in_datetime);
        const formattedPunchOutDateTime = formatDateToSQL(this.state.punch_out_datetime);
        // console.log("formattedPunchInDateTime", formattedPunchInDateTime, "formattedPunchOutDateTime", formattedPunchOutDateTime);
        // Get current date and time for regularized_datetime
        const currentDateTime = new Date();
        const formattedRegularizedDateTime = formatDateToSQL(currentDateTime.toISOString());

        var formData = {
            employee_id: this.state.employee_id,
            employee_attendance_id: this.state.employee_attendance_id,
            regularization_request_remark: JSON.stringify({
                "punch_in_datetime": (this.state.request_type == 1 || this.state.request_type == 3) ? formattedPunchInDateTime : '',
                "punch_out_datetime": (this.state.request_type == 2 || this.state.request_type == 3) ? formattedPunchOutDateTime : '',
                "remark": this.state.remark_by_employee,
            }),
            regularized_datetime: formattedRegularizedDateTime,
            remark_by_employee: this.state.remark_by_employee,
            request_type: this.state.request_type,
        };
        if (this.state.attendance_regularization_request_id != 0) {
            formData.attendance_regularization_request_id = this.state.attendance_regularization_request_id;
        }
        axios.post(`${apiURL}Attendance/RegularizationRequest`, formData, { headers }).then((response) => {
            const { success } = response.data;

            if (success === true) {
                this.resetForm();
                // this.closeRef.current.click();
                this.setState({ modal_type: false });
                this.GetList();
                Swal.fire({
                    title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    showConfirmButton: true,
                })
            } else {
                // this.closeRef.current.click();
                Swal.fire({
                    title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    showConfirmButton: true,
                })
                this.setState({ loadingList: true }, (prevState) => {
                    this.GetList();
                })
            }
        });
    };

    
    handleCancelRegularization = (id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        Swal.fire({
            title: 'Are you sure?',
            text: "You want to cancel regularization?",
            input: 'text',
            inputPlaceholder: 'Enter your Remark',
            inputValidator: (value) => {
                if (!value) {
                return 'Remark cannot be empty';
                }
            },
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
        }).then((result) => {
            if (result.isConfirmed) {
                
                let date = currentDateAndTime();
                const formData = {
                    attendance_regularization_request_id: id,
                    remark_by_employee: result?.value || "",
                };

                axios
                .post(`${apiURL}Attendance/CancelRegularizationRequest`, formData, {
                    params: { date: date },
                    headers
                })
                .then((response) => {
                    Swal.fire({
                        title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: response.data.success === true ? 'success' : 'error',
                        showConfirmButton: true,
                        allowOutsideClick:false,
                    });

                    // this.setState({ status: false });
                    if (response.data.success === true) {
                        this.GetRegularizationLogs();
                        this.GetList();
                        // console.log("CancelRegularizationRequest ===================================>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
                    }
                })
                .catch((error) => {
                    Swal.fire({
                        title: '<strong>Error</strong>',
                        html: error.message,
                        icon: 'error',
                        showConfirmButton: true,
                        allowOutsideClick:false,
                    });
                });
            }
        })

    }

    handlePunchIn = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        let formData = {
            punch_in_latlng: `${this.state.punch_lat},${this.state.punch_lng}`,
            punch_in_ip_address: this.state.ipAddress,
            punch_in_datetime: currentDateAndTime(),
            act_in_datetime: `${new Date().toISOString()?.split("T")[0]} ${new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}`,
            punch_in_from: '1'
        };
        // if (this.state.punch_lat && this.state.punch_lng) {
            this.setState({ loadingMarkAttendance:"1" });
        axios.post(`${apiURL}Home/PunchIn`, formData, { headers })
        .then((response) => {
            const { success } = response.data;
            if (success === true) {
                // this.closeRef.current.click();
                this.setState({ successMsg: response.data.message, errorMsg: false, loadingMarkAttendance:false });
                // Swal.fire({
                //     title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                //     text: response.data.message,
                //     icon: response.data.success === true ? 'success' : 'error',
                //     timer: 2000,
                //     timerProgressBar: true,
                //     showConfirmButton: false,
                // })
            } else {

                // Swal.fire({
                //     title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                //     text: response.data.message,
                //     icon: response.data.success === true ? 'success' : 'error',
                //     timer: 2000,
                //     timerProgressBar: true,
                //     showConfirmButton: false,
                // })
                this.setState({ successMsg: false,shouldShowPunchInButton: true, shouldShowPunchOutButton: false, errorMsg: response.data.message, loadingMarkAttendance:false })
            }
            this.GetList();

        })
        .catch((error)=>{
            this.setState({ loadingMarkAttendance:false });
            this.GetList();
            Swal.fire({
                title: `<strong>Failed</strong>`,
                text: "Oops... Something went wrong! Unable to punch in.",
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false,
            });
        });
        // }
    };
    handlePunchOut = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        Swal.fire({
            title: 'Are you sure?',
            text: "You are about to punch out. Do you want to continue?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, punch out!',
            cancelButtonText: 'No, cancel!',
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ loadingMarkAttendance:"2" });
                let formData = {
                    punch_out_latlng: `${this.state.punch_lat},${this.state.punch_lng}`,
                    punch_out_ip_address: this.state.ipAddress,
                    punch_out_datetime: currentDateAndTime(),
                    employee_attendance_id: this.state.rows[this.state.rows?.length-1]?.employee_attendance_id,
                    punch_in_datetime: this.state.rows[this.state.rows?.length-1]?.PunchIn,
                    act_out_datetime: `${new Date().toISOString()?.split("T")[0]} ${new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}`,
                    act_in_datetime: `${this.state.rows[this.state.rows?.length-1]?.PunchIn?.split(" ")[0]} ${this.state.rows[this.state.rows?.length-1]?.PunchIn?.split(" ")[1]?.split(":")[0]}:${this.state.rows[0]?.PunchIn?.split(" ")[1]?.split(":")[1]}`,
                    punch_out_from: '1'
                };

                axios.post(`${apiURL}Home/PunchOut`, formData, { headers })
                    .then((response) => {
                        const { success } = response.data;
                        if (success === true) {
                            // this.closeRef.current.click();
                            this.setState({ successMsg: response.data.message, errorMsg: false,loadingMarkAttendance:false });
                            // Swal.fire({
                            //     title: `<strong>Success</strong>`,
                            //     text: response.data.message,
                            //     icon: 'success',
                            //     timer: 2000,
                            //     timerProgressBar: true,
                            //     showConfirmButton: false,
                            // });
                        } else {
                            // Swal.fire({
                            //     title: `<strong>Failed</strong>`,
                            //     text: response.data.message,
                            //     icon: 'error',
                            //     timer: 2000,
                            //     timerProgressBar: true,
                            //     showConfirmButton: false,
                            // });
                            this.setState({ successMsg: false,shouldShowPunchInButton: false,
                                shouldShowPunchOutButton: true, errorMsg: response.data.message, loadingMarkAttendance:false });
                        }
                        this.GetList();
                    })
                    .catch((error)=>{
                        this.setState({ loadingMarkAttendance:false });
                        this.GetList();
                        Swal.fire({
                            title: `<strong>Failed</strong>`,
                            text: "Oops... Something went wrong! Unable to punch out.",
                            icon: 'error',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        });
                    });
            } else {
                this.setState({ loadingMarkAttendance:false });
                this.GetList();
                Swal.fire({
                    title: 'Cancelled',
                    text: 'Punch out was cancelled.',
                    icon: 'info',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });
                return;
            }
        });
    };
    handleMarkIn = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        let formData = {
            punch_in_latlng: `${this.state.punch_lat},${this.state.punch_lng}`,
            punch_in_ip_address: this.state.ipAddress,
            punch_in_datetime: currentDateAndTime(),
            act_in_datetime: `${new Date().toISOString()?.split("T")[0]} ${new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}`,
            punch_in_from: '1'
        };
        this.setState({ loadingMarkAttendance:"3" });
        // if (this.state.punch_lat && this.state.punch_lng) {
        axios.post(`${apiURL}Home/MultiAttendancePunchIn`, formData, { headers }).then((response) => {
            const { success } = response.data;
            if (success === true) {
                // this.closeRef.current.click();
                this.setState({ successMsg: response.data.message, errorMsg: false, loadingMarkAttendance:false });
                // Swal.fire({
                //     title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                //     text: response.data.message,
                //     icon: response.data.success === true ? 'success' : 'error',
                //     timer: 2000,
                //     timerProgressBar: true,
                //     showConfirmButton: false,
                // })
            } else {

                // Swal.fire({
                //     title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                //     text: response.data.message,
                //     icon: response.data.success === true ? 'success' : 'error',
                //     timer: 2000,
                //     timerProgressBar: true,
                //     showConfirmButton: false,
                // })
                this.setState({ successMsg: false,shouldShowPunchInButton: true,
                    shouldShowPunchOutButton: false, errorMsg: response.data.message, loadingMarkAttendance:false });
            }
            this.GetList();
        })
        .catch((error)=>{
            this.setState({ loadingMarkAttendance:false });
            this.GetList();
            Swal.fire({
                title: `<strong>Failed</strong>`,
                text: "Oops... Something went wrong! Unable to mark in.",
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false,
            });
        });
        // }
    };
    handleMarkOut = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        Swal.fire({
            title: 'Are you sure?',
            text: "You are about to punch out. Do you want to continue?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, mark out!',
            cancelButtonText: 'No, cancel!',
            // reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ loadingMarkAttendance:"4" });
                let formData = {
                    punch_out_latlng: `${this.state.punch_lat},${this.state.punch_lng}`,
                    punch_out_ip_address: this.state.ipAddress,
                    punch_out_datetime: currentDateAndTime(),
                    employee_attendance_id: this.state.rows[this.state.rows?.length-1]?.employee_attendance_id,
                    punch_in_datetime: this.state.rows[this.state.rows?.length-1]?.PunchIn,
                    act_out_datetime: `${new Date().toISOString()?.split("T")[0]} ${new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}`,   
                    punch_out_from: '1'
                };

                axios.post(`${apiURL}Home/MultiAttendancePunchOut`, formData, { headers })
                    .then((response) => {
                        const { success } = response.data;
                        if (success === true) {
                            // this.closeRef.current.click();
                            this.setState({ successMsg: response.data.message, errorMsg: false,loadingMarkAttendance:false });
                            // Swal.fire({
                            //     title: `<strong>Success</strong>`,
                            //     text: response.data.message,
                            //     icon: 'success',
                            //     timer: 2000,
                            //     timerProgressBar: true,
                            //     showConfirmButton: false,
                            // });
                        } else {
                            // Swal.fire({
                            //     title: `<strong>Failed</strong>`,
                            //     text: response.data.message,
                            //     icon: 'error',
                            //     timer: 2000,
                            //     timerProgressBar: true,
                            //     showConfirmButton: false,
                            // });
                            this.setState({ successMsg: false,shouldShowPunchInButton: false,
                                shouldShowPunchOutButton: true, errorMsg: response.data.message, loadingMarkAttendance:false });
                        }
                        this.GetList()
                    })
                    .catch((error)=>{
                        this.setState({ loadingMarkAttendance:false });
                        this.GetList();
                        Swal.fire({
                            title: `<strong>Failed</strong>`,
                            text: "Oops... Something went wrong! Unable to mark out.",
                            icon: 'error',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        });
                    });
            } else {
                this.setState({ loadingMarkAttendance:false });
                this.GetList();
                Swal.fire({
                    title: 'Cancelled',
                    text: 'Punch out was cancelled.',
                    icon: 'info',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });
                return; 
            }
        });
    };

    getLocation = (isPunchIn) => {

        this.setState({
            shouldShowPunchInButton: false,
            shouldShowPunchOutButton: false,
            ExtraPunchInButton: false,
            ExtraPunchOutButton: false,
        },()=>{
            axios
            .get('https://api.ipify.org?format=json')
            .then(response => {
                // console.log("response",response);
                // console.log("response.data.ip",response.data.ip);
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        this.setState(
                            {
                                punch_lat: position.coords.latitude || "",
                                punch_lng: position.coords.longitude || "",
                                ipAddress: response.data.ip || "",
                            },
                            () => {
                                if (isPunchIn === "punchIn") {
                                    this.handlePunchIn();
                                } 
                                else if (isPunchIn === "punchOut") {
                                    this.handlePunchOut();
                                }
                                else if (isPunchIn === "markIn") {
                                    this.handleMarkIn();
                                }
                                else if (isPunchIn === "markOut") {
                                    this.handleMarkOut();
                                }
                            }
                        );
                    },
                    (error) => {
                        this.setState(
                            {
                                punch_lat: "",
                                punch_lng: "",
                                ipAddress: response.data.ip || "",
                            },
                            () => {
                                if (isPunchIn === "punchIn") {
                                    this.handlePunchIn();
                                }
                                else if (isPunchIn === "punchOut") {
                                    this.handlePunchOut();
                                }
                                else if (isPunchIn === "markIn") {
                                    this.handleMarkIn();
                                }
                                else if (isPunchIn === "markOut") {
                                    this.handleMarkOut();
                                }
                            }
                        );
                        // this.GetList();
                        let errorMessage = '';
                        switch (error.code) {
                            case error.PERMISSION_DENIED:
                                errorMessage = "User denied the request for Geolocation.";
                                break;
                            case error.POSITION_UNAVAILABLE:
                                errorMessage = "Location information is unavailable.";
                                break;
                            case error.TIMEOUT:
                                errorMessage = "The request to get user location timed out.";
                                break;
                            case error.UNKNOWN_ERROR:
                                errorMessage = "An unknown error occurred.";
                                break;
                        }
                        // console.error("Geolocation error:", errorMessage, error);
                        this.setState({
                            error: errorMessage,
                            loadingMarkAttendance:false,
                        });
                    }
                );
            })
            .catch(error => {
                this.setState({loadingMarkAttendance:false,});
                console.error('Error fetching the IP address:', error);
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        this.setState(
                            {
                                punch_lat: position.coords.latitude || "",
                                punch_lng: position.coords.longitude || "",
                                ipAddress:  "error",
                            },
                            () => {
                                if (isPunchIn === "punchIn") {
                                    this.handlePunchIn();
                                } 
                                else if (isPunchIn === "punchOut") {
                                    this.handlePunchOut();
                                }
                                else if (isPunchIn === "markIn") {
                                    this.handleMarkIn();
                                }
                                else if (isPunchIn === "markOut") {
                                    this.handleMarkOut();
                                }
                            }
                        );
                    },
                    (error) => {
                        this.setState(
                            {
                                punch_lat: "",
                                punch_lng: "",
                                ipAddress: response.data.ip || "",
                            },
                            () => {
                                if (isPunchIn === "punchIn") {
                                    this.handlePunchIn();
                                }
                                else if (isPunchIn === "punchOut") {
                                    this.handlePunchOut();
                                }
                                else if (isPunchIn === "markIn") {
                                    this.handleMarkIn();
                                }
                                else if (isPunchIn === "markOut") {
                                    this.handleMarkOut();
                                }
                            }
                        );
                        // this.GetList();
                        let errorMessage = '';
                        switch (error.code) {
                            case error.PERMISSION_DENIED:
                                errorMessage = "User denied the request for Geolocation.";
                                break;
                            case error.POSITION_UNAVAILABLE:
                                errorMessage = "Location information is unavailable.";
                                break;
                            case error.TIMEOUT:
                                errorMessage = "The request to get user location timed out.";
                                break;
                            case error.UNKNOWN_ERROR:
                                errorMessage = "An unknown error occurred.";
                                break;
                        }
                        // console.error("Geolocation error:", errorMessage, error);
                        this.setState({
                            error: errorMessage,
                            loadingMarkAttendance:false,
                        });
                    }
                );
                // Swal.fire({
                //     title: 'Cancelled',
                //     text: 'Unable to get your IP address! Please check your device settings.',
                //     icon: 'info',
                //     showConfirmButton: true,
                //     allowOutsideClick: false,
                // });
            });
        });
        // navigator.geolocation.getCurrentPosition(
        //     (position) => {
        //         console.log("GPS Latitude:", position.coords.latitude);
        //         console.log("GPS Longitude:", position.coords.longitude);

        //         fetch("https://api64.ipify.org?format=json")
        //             .then(response => response.json())
        //             .then(data => {
        //                 console.log("IP Address:", data.ip);
                        
        //                 this.setState(
        //                     {
        //                         punch_lat: position.coords.latitude || "",
        //                         punch_lng: position.coords.longitude || "",
        //                         ipAddress: data.ip || "",
        //                     },
        //                     () => {
        //                         if (isPunchIn === "punchIn") {
        //                             this.handlePunchIn();
        //                         } 
        //                         else if (isPunchIn === "punchOut") {
        //                             this.handlePunchOut();
        //                         }
        //                         else if (isPunchIn === "markIn") {
        //                             this.handleMarkIn();
        //                         }
        //                         else if (isPunchIn === "markOut") {
        //                             this.handleMarkOut();
        //                         }
        //                     }
        //                 );
        //             })
        //             .catch(error => console.error("Error getting IP:", error));
        //     },
        //     (error) => console.error("Error getting location:", error),
        //     {
        //         enableHighAccuracy: true, 
        //         timeout: 15000, 
        //         maximumAge: 5000, 
        //     }
        // );
    };
    // getLocation = (isPunchIn) => {

    //     this.setState({
    //         shouldShowPunchInButton: false,
    //         shouldShowPunchOutButton: false,
    //     });

    //     axios
    //         .get('https://api.ipify.org?format=json')
    //         .then(response => {
    //             // console.log("response.data.ip",response.data.ip);
    //             navigator.geolocation.getCurrentPosition(
    //                 (position) => {
    //                     this.setState(
    //                         {
    //                             punch_lat: position.coords.latitude || "",
    //                             punch_lng: position.coords.longitude || "",
    //                             ipAddress: response.data.ip || "",
    //                         },
    //                         () => {
    //                             if (isPunchIn === "punchIn") {
    //                                 this.handlePunchIn();
    //                             } 
    //                             else if (isPunchIn === "punchOut") {
    //                                 this.handlePunchOut();
    //                             }
    //                             else if (isPunchIn === "markIn") {
    //                                 this.handleMarkIn();
    //                             }
    //                             else if (isPunchIn === "markOut") {
    //                                 this.handleMarkOut();
    //                             }
    //                         }
    //                     );
    //                 },
    //                 (error) => {
    //                     this.setState(
    //                         {
    //                             punch_lat: "",
    //                             punch_lng: "",
    //                             ipAddress: response.data.ip || "",
    //                         },
    //                         () => {
    //                             if (isPunchIn === "punchIn") {
    //                                 this.handlePunchIn();
    //                             } else if (isPunchIn === "punchOut") {
    //                                 this.handlePunchOut();
    //                             }
    //                         }
    //                     );
    //                     // this.GetList();
    //                     let errorMessage = '';
    //                     switch (error.code) {
    //                         case error.PERMISSION_DENIED:
    //                             errorMessage = "User denied the request for Geolocation.";
    //                             break;
    //                         case error.POSITION_UNAVAILABLE:
    //                             errorMessage = "Location information is unavailable.";
    //                             break;
    //                         case error.TIMEOUT:
    //                             errorMessage = "The request to get user location timed out.";
    //                             break;
    //                         case error.UNKNOWN_ERROR:
    //                             errorMessage = "An unknown error occurred.";
    //                             break;
    //                     }
    //                     // console.error("Geolocation error:", errorMessage, error);
    //                     this.setState({
    //                         error: errorMessage,
    //                     });
    //                 }
    //             );
    //         })
    //         .catch(error => {
    //             this.setState({loadingMarkAttendance:false,})
    //             console.error('Error fetching the IP address:', error);
    //             Swal.fire({
    //                 title: 'Cancelled',
    //                 text: 'Unable to get your IP address! Please check your device settings.',
    //                 icon: 'info',
    //                 showConfirmButton: true,
    //                 allowOutsideClick: false,
    //             });
    //         });


    // };

    formatGetedDateTime = (dateTimeString) => {
        const date = new Date(dateTimeString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    }

    getInitials = (leaveTypeName) => {
        if (leaveTypeName) {
            return leaveTypeName.split(' ').map(word => word[0]).join('');
        }
    }
    checkIsLeave = (data) => {
        const leaveFromDate = data.employee_leave_from_date;
        const leaveToDate = data.employee_leave_to_date;
        let created_datetime = data.attendance_date;
        const createdDate = created_datetime.split(' ')[0];

        if (data.employee_leave_id) {
            if (createdDate === leaveFromDate) {
                return data.employee_leave_from_day_unit === "First Half" ? ' / 1' : data.employee_leave_from_day_unit === "Second Half" ? ' / 2' : '';
            }
            if (createdDate === leaveToDate) {
                return data.employee_leave_to_day_unit === "First Half" ? ' / 1' : data.employee_leave_to_day_unit === "Second Half" ? ' / 2' : '';
            }
        } else {
            return '';
        }
    }
    calculateWorkingHours = (data) => {
        let shiftStart = data?.ShiftStart;
        let shiftEnd = data?.ShiftEnd;
        let punchIn = data?.PunchIn?.split(" ")[1]
        let punchOut = data?.PunchOut?.split(" ")[1]
        if (shiftStart && shiftEnd && punchIn && punchOut) {
            // Helper function to parse time strings into Date objects
            const parseTime = (timeStr) => {
                const [hours, minutes] = timeStr.split(':').map(Number);
                return new Date(0, 0, 0, hours, minutes);
            };

            // Helper function to calculate the difference in hours between two Date objects
            const calculateHoursDifference = (start, end) => {
                const millisecondsPerHour = 1000 * 60 * 60;
                return (end - start) / millisecondsPerHour;
            };

            // Parse times
            const shiftStartTime = parseTime(shiftStart);
            const shiftEndTime = parseTime(shiftEnd);
            const punchInTime = parseTime(punchIn);
            const punchOutTime = parseTime(punchOut);

            // Calculate total working hours
            let totalWorkingHours = calculateHoursDifference(shiftStartTime, shiftEndTime);

            // Calculate half of the total working hours
            const halfWorkingHours = totalWorkingHours / 2;

            // Calculate punch hours
            let punchHours = calculateHoursDifference(punchInTime, punchOutTime);
            // Compare punch hours with half of the working hours
            return punchHours >= halfWorkingHours;
        }
        else {
            return false;
        }


    }
    SetDates = () => {
        const { startOfMonth, endOfMonth } = GetCurrentMonthStartEndDates();
        this.setState({
            from_date: startOfMonth,
            to_date: endOfMonth,
        }, () => {
            this.GetList();
        });
    }

    GetRegularizationLogs = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Attendance/GetRegularizationLogs`, {
            params: {
                attendance_regularization_request_id: this.state.attendance_regularization_request_id,
            }, headers
        }).then((response) => {
            const { data, success } = response.data;
            if (success === true) {
                this.setState({
                    logs_data: data,

                });
            }
        });

    }

    GetRegularizationSettings = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Attendance/GetRegularizationSettings`, { headers }).then((response) => {
            const { data, success } = response.data;
            if (success === true && data.length != 0) {
                this.setState({
                    rz_data: data[0],
                });
            }
        });
    }


    resetForm = () => {
        this.setState({
            employee_attendance_id: 0,
            employee_id: 0,
            attendance_regularization_request_id: 0,
            punch_in_datetime: '',
            punch_out_datetime: '',
            remark_by_employee: '',
            request_type: 0,

        });
    }


    CheckLeaveAndRegularization = (data) => {
        let leave = data.request_type === '3' || data.employee_leave_status === 0 || data.employee_leave_status === 2 ? false : true;
        let Regularization = false;
        let leaveDetails = data.employee_leave_id ? true : false;
        let RegularizationDetails = data.attendance_regularization_request_id ? true : false;

        function getDaysDifference(date) {
            const date1 = new Date(date);
            const date2 = new Date(currentDateAndTime("T"));
            const timeDifference = date2.getTime() - date1.getTime();
            const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
            return daysDifference;
        }

        function checkLeave() {
            const leaveFromDate = data.employee_leave_from_date;
            const leaveToDate = data.employee_leave_to_date;
            let created_datetime = data.created_date;
            const createdDate = created_datetime.split(' ')[0];
            if (data.employee_leave_id) {
                if (createdDate === leaveFromDate) {
                    return data.employee_leave_from_day_unit === "Full Day" ? false : true;
                }
                if (createdDate === leaveToDate) {
                    return data.employee_leave_to_day_unit === "Full Day" ? false : true;
                }
                if (createdDate > leaveFromDate && createdDate < leaveToDate) {
                    return false;
                }
                return true;
            } else {
                return true;
            }
        }

        const checkLeaveStatus = checkLeave();

        leave = !checkLeaveStatus ? false : leave;

        const attcondtion = data.regularization_request_status == "1" || data.regularization_request_status == "3" || data.regularization_request_status == "4" || data.regularization_request_status === null;
        // console.log("this.state.rz_data", this.state.rz_data);
        if (attcondtion && checkLeaveStatus) {
            // console.log("795",getDaysDifference(data.attendance_date),this.state.rz_data.regularization_apply_days)
            if (!this.state.rz_data.regularization_apply_days) {
                Regularization = true;
            } else if (getDaysDifference(data.attendance_date) <= this.state.rz_data.regularization_apply_days) {
                Regularization = true;
            } else {
                Regularization = false;
            }
        } else {
            Regularization = false;
        }
        return { leave: leave, leaveDetails: leaveDetails, Regularization: Regularization, RegularizationDetails: RegularizationDetails };
    }




    handleLimitChange = (e) => {
        this.setState(
            {
                limit: parseInt(e.target.value, 10),
                page: 1,
            },
            () => {
                this.GetList();
            }
        );
    };

    render() {
        const limitOptions = [10, 25, 50, 100, 200, 500, this.state.total_records];
        const options = [
            { value: '0', label: 'Absent' },
            { value: '1', label: 'Present' },
            { value: '2', label: 'Half Day' },
            // { value: '3', label: 'Regularized' },
            // { value: '4', label: 'Auto Regularized' },
            // { value: '5', label: 'Regularization Rejected' },
            // { value: '6', label: 'Late Mark' },
            // { value: '7', label: 'Early Mark' },
            // { value: '8', label: 'Leave' },
            // { value: '9', label: 'Holiday' },
        ];


        const { loadingLocation, showLocation } = this.state;
        return (
            this.state.loadingList === false ?
                (
                    <div className="main-content" >
                        <div className="page-content">
                            <div className="container-fluid">
                                <br />
                                <PageTitle title={`My Attendance`} primary={`My Details`} />
                                <div className='card'>
                                    <div className='card-body'>
                                        {/* <div class="card-header bg-light bg-gradient">
                                            <h6 className="card-title mb-0 text-center" >MY ATTENDANCE</h6>
                                        </div> */}
                                        <div className="row">
                                            <div className="col-lg-12 " >
                                                {/* <div className="card-header">
                                                </div> */}
                                            <div className="row">
                                                <div className=''>
                                                    <label>Mark Attendance</label>
                                                    <div className=' d-flex flex-wrap gap-3 mb-1'>
                                                        {/* <button disabled={!this.state.shouldShowPunchInButton} onClick={() => this.getLocation("punchIn")}
                                                        className="btn btn-info  waves-effect  waves-light d-flex align-items-center gap-1">
                                                        {this.state.loadingMarkAttendance==="1"?
                                                        <span
                                                        class="spinner-border flex-shrink-0 "
                                                        role="status"
                                                        style={{
                                                        width: "0.9rem",
                                                        height: "0.9rem",
                                                        borderWidth: "2px",
                                                        }}>
                                                        <span class="visually-hidden">Loading...</span>
                                                        </span>:
                                                        <i className="bx bx-calendar-check label-icon align-middle fs-16  " />}
                                                            Punch In
                                                        </button> */}
                                                        <SubmitButton otherClasses='noWrap' onClick={()=>{this.getLocation("punchIn")}} 
                                                        disabled={!this.state.shouldShowPunchInButton}
                                                        loading={this.state.loadingMarkAttendance==="1"} loadingMessage='Loading' 
                                                        buttonName={"Punch In"}  type='info' icon='bx bx-calendar-check' />

                                                        {/* <button disabled={!this.state.shouldShowPunchOutButton}  onClick={() => this.getLocation("punchOut")} 
                                                        className="btn btn-secondary  waves-effect  waves-light d-flex align-items-center gap-1" >
                                                        {this.state.loadingMarkAttendance === "2"?
                                                        <span
                                                        class="spinner-border flex-shrink-0 "
                                                        role="status"
                                                        style={{
                                                        width: "0.9rem",
                                                        height: "0.9rem",
                                                        borderWidth: "2px",
                                                        }}>
                                                        <span class="visually-hidden">Loading...</span>
                                                    </span>:
                                                        <i className="bx bx-calendar-x label-icon align-middle fs-16  " />}
                                                            Punch Out
                                                        </button> */}
                                                        <SubmitButton otherClasses='noWrap' onClick={()=>{this.getLocation("punchOut")}} 
                                                        disabled={!this.state.shouldShowPunchOutButton}
                                                        loading={this.state.loadingMarkAttendance==="2"} loadingMessage='Loading' 
                                                        buttonName={"Punch Out"}  type='secondary' icon='bx bx-calendar-x' />
                                                    </div>
                                                </div>
                                                {this.state.shouldShowExtraPunchButton && (
                                                    <div className=''>
                                                        <label>Mark Visit</label>
                                                        <div className='d-flex flex-wrap gap-3 mb-1'>
                                                            {/* <button disabled={!this.state.ExtraPunchInButton} onClick={() => this.getLocation("markIn")}
                                                            className="btn btn-success  waves-effect  waves-light d-flex align-items-center gap-1">
                                                            {this.state.loadingMarkAttendance==="3"?
                                                            <span
                                                            class="spinner-border flex-shrink-0 "
                                                            role="status"
                                                            style={{
                                                            width: "0.9rem",
                                                            height: "0.9rem",
                                                            borderWidth: "2px",
                                                            }}>
                                                            <span class="visually-hidden">Loading...</span>
                                                            </span>:
                                                            <i className="bx bx-calendar-check label-icon align-middle fs-16  " />}
                                                                Visit In
                                                            </button> */}
                                                            <SubmitButton otherClasses='noWrap' onClick={()=>{this.getLocation("markIn")}} 
                                                            disabled={!this.state.ExtraPunchInButton}
                                                            loading={this.state.loadingMarkAttendance==="3"} loadingMessage='Loading' 
                                                            buttonName={"Visit In"}  type='info' icon='bx bx-calendar-check' />
                                                            {/* <button disabled={!this.state.ExtraPunchOutButton}  onClick={() => this.getLocation("markOut")} 
                                                            className="btn btn-secondary  waves-effect  waves-light d-flex align-items-center gap-1" >
                                                            {this.state.loadingMarkAttendance === "4"?
                                                            <span
                                                            class="spinner-border flex-shrink-0 "
                                                            role="status"
                                                            style={{
                                                            width: "0.9rem",
                                                            height: "0.9rem",
                                                            borderWidth: "2px",
                                                            }}>
                                                            <span class="visually-hidden">Loading...</span>
                                                        </span>:
                                                            <i className="bx bx-calendar-x label-icon align-middle fs-16  " />}
                                                                Visit Out
                                                            </button> */}
                                                            <SubmitButton otherClasses='noWrap' onClick={()=>{this.getLocation("markOut")}} 
                                                            disabled={!this.state.ExtraPunchOutButton}
                                                            loading={this.state.loadingMarkAttendance==="4"} loadingMessage='Loading' 
                                                            buttonName={"Visit Out"}  type='secondary' icon='bx bx-calendar-x' />
                                                        </div>
                                                    </div>
                                                )}
                                                
                                            </div>
                                            
                                            {this.state.viewEmployeeVisitLogs && (
                                                <div className="modal show" style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)", }}  >
                                                <div className=" m-auto mt-3 w-modal">
                                                    <div className="modal-content">
                                                    <div className="modal-header pb-0">
                                                        <h5 className="modal-title" id="rmModalLabel">Employee Visited logs</h5>
                                                        <button type="button" className="btn-close" onClick={()=> this.setState({ viewEmployeeVisitLogs:false })} aria-label="Close" />
                                                    </div>
                                                    <div className="modal-body pt-0">
                                                    {/* {!showLocation && (
                                                        <h5>Date: {Array.isArray(this.state.viewEmployeeVisitLogs) && this.state.viewEmployeeVisitLogs.length > 0 ? 
                                                        this.state.viewEmployeeVisitLogs[0]?.attendance_date ? formatDate(this.state.viewEmployeeVisitLogs[0]?.attendance_date) : "--" :"--"}</h5>
                                                    )} */}
                                                    {showLocation==="2" && (
                                                        <div className={`${this.state.punch_in_date || this.state.punch_out_date ? '' : 'd-none'} rounded-3 position-relative card-body grayBlurShadow mx-3`}>
                                                            <h6 className={`${this.state.punch_in_date !== null ? '' : 'd-none'} card-title mb-3 d-flex align-items-center mt-md-0 mt-2 me-md-0 me-2`}>
                                                                <span className='bx bx-log-in fs-3' style={{ marginRight: "10px" }} />
                                                                <span>Punch In Date : {this.state.punch_in_date} , Time : {this.state.punch_in_time}</span>
                                                            </h6>
                                                            <h6 className={`${this.state.punch_out_date !== null ? '' : 'd-none'} card-title mb-3 d-flex align-items-center mt-md-0 mt-2 me-md-0 me-2`}>
                                                                <span className='bx bx-log-out fs-3' style={{ marginRight: "10px" }} />
                                                                <span>Punch Out Date : {this.state.punch_out_date} , Time : {this.state.punch_out_time}</span>
                                                            </h6>
                                                            <h6 className={`card-title d-flex align-items-center`}>
                                                                <span className='ri ri-map-pin-2-line fs-3' style={{ marginRight: "10px" }}></span>
                                                                <span>{this.state.punch_in_date === null ? (this.state.punch_out_address) : this.state.punch_in_address}</span>
                                                            </h6>
                                                            <span onClick={() => { this.setState({ showLocation: false }) }} style={{ right: "0.2rem", top: "0.2rem", cursor: "pointer" }} className=" position-absolute text-danger"><i className="ri-close-circle-line" style={{ fontSize: '26px' }}/></span>
                                                            {/* <span onClick={() => { this.setState({ showLocation: false }) }} style={{ right: "1rem", top: "1rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span> */}
                                                        </div>)}
                                                        
                                                        <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                                                            <table className=" position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">
                                                                <thead className='bg-primary text-light bg-gradient sticky-top z-1'>
                                                                    <tr>
                                                                        <th style={{ width:"10%"}} className="text-center">Sr.No.</th>
                                                                        {/* <th>Goal Title</th> */}
                                                                        <th style={{ width:"45%"}} className="text-center">Visit In</th>
                                                                        <th style={{ width:"45%"}} className="text-center">Visit Out</th>
                                                                        {/* <th  style={{ width:"10%"}} className="text-center">Status</th> */}
                                                                    </tr>
                                                                </thead>
                                                                {Array.isArray(this.state.viewEmployeeVisitLogs) && this.state.viewEmployeeVisitLogs.length === 0 ? (
                                                                    <tbody>
                                                                    <tr>
                                                                        <td colSpan={11}>
                                                                        <NoRecords />
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                ) :
                                                                    <tbody>
                                                                    {Array.isArray(this.state.viewEmployeeVisitLogs) && this.state.viewEmployeeVisitLogs.map((row,idx) => {
                                                                        return (
                                                                        <tr key={row.employee_id}>
                                                                            <td className="text-center">{idx+1}</td>                                                                        
                                                                            {/* <td className="text-center">{row?.punch_in_datetime ? formatDate(row?.punch_in_datetime) : "--"}</td>
                                                                            <td className="text-center">{row?.punch_out_datetime ? formatDate(row?.punch_out_datetime) : "--"}</td> */}
                                                                            <td>
                                                                                    <div className=" d-flex flex-column gap-0 justify-content-start">
                                                                                        <span className={`${row.punch_in_address && "cursorPointer"} text-info  d-flex justify-content-start`} 
                                                                                        style={{ textDecoration: "underline", }} onClick={() => {
                                                                                            if (row.punch_in_address) {
                                                                                                this.showInMap(row.punch_in_latlng, formatDate(row.punch_in_datetime), formatTime(row.punch_in_datetime), row.punch_in_address, "2");
                                                                                            }
                                                                                        }}>
                                                                                            <span className='noWrap'>{formatDate(row.punch_in_datetime)} {formatTime(row.punch_in_datetime)}</span>
                                                                                        </span>
                                                                                        <div style={{ width: "139px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                                            <small>{row.punch_in_address ? row.punch_in_address : row.punch_in_datetime && !row.punch_in_address ? "Location is not captured." : "--"}</small>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                                <td >
                                                                                    <div className=" d-flex flex-column gap-0 justify-content-start">
                                                                                        <span className={`${row.punch_out_address && "cursorPointer"} text-info  d-flex justify-content-start ${!row.punch_out_datetime ? "d-none" : ""}`} 
                                                                                        style={{ textDecoration: "underline",}} onClick={() => {
                                                                                            if (row.punch_out_address) {
                                                                                                this.showOutMap(row.punch_out_latlng, formatDate(row.punch_out_datetime), formatTime(row.punch_out_datetime), row.punch_out_address, "2");
                                                                                            }
                                                                                        }}>
                                                                                            <span className=' noWrap'>{formatDate(row.punch_out_datetime)} {formatTime(row.punch_out_datetime)}</span>
                                                                                        </span>
                                                                                        <div style={{ width: "139px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                                            <small>{row.punch_out_address ? row.punch_out_address : row.punch_out_datetime && !row.punch_out_address ? "Location is not captured." : "--"}</small>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                        </tr>
                                                                        );
                                                                    })}
                                                                    </tbody>}
                                                            </table>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                                </div>
                                            )}
                                                {/* <div className='mt-3 '> */}
                                                {/* <MapContainer center={this.state.position} zoom={16} style={{ height: "550px" }} scrollWheelZoom={false}>

                                                        <TileLayer
                                                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                        />
                                                        <Marker position={this.state.position}>
                                                            <Popup>
                                                                A pretty CSS3 popup. <br /> Easily customizable.
                                                            </Popup>
                                                        </Marker>
                                                    </MapContainer> */}
                                                {/* <Mapper position={[this.state.position[0], this.state.position[1]]} punchin={`${this.state.punch_in_time} ${this.state.punch_in_date}`} punchout={`${this.state.punch_out_time} ${this.state.punch_out_date}`} /> */}
                                                {/* </div> */}
                                            </div>
                                            <div className="col-lg-12 ">
                                                {this.state.successMsg ?
                                                    <div className=" position-relative alert alert-success mt-3" role="alert">
                                                        {this.state.successMsg} <span onClick={() => { this.setState({ successMsg: false }) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                                                    </div>
                                                    : null
                                                }
                                                {this.state.errorMsg ?
                                                    <div className=" position-relative alert alert-danger mt-3" role="alert">
                                                        {this.state.errorMsg} <span onClick={() => { this.setState({ errorMsg: false }) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                                                    </div> : null
                                                }
                                            </div>
                                            <div className="card-header pt-0">
                                                <div className="row">
                                                    {/* <div className='col-md-3'>
                                                        <TextBox type="Date" id="from_date" name="from_date" label="From date" value={this.state.from_date} change={this.handleInputChange} />
                                                    </div>
                                                    <div className='col-md-3'>
                                                        <TextBox type="Date" id="to_date" name="to_date" label="To date" value={this.state.to_date} change={this.handleInputChange} />
                                                    </div> */}
                                                    <div className='col-md-3 position-relative mb-5'>
                                                        <div><label>Month</label></div>
                                                        <div style={{ "zIndex": 10, "width": "90%" }} className=' position-absolute'>
                                                            <Select onChange={(selectOption) => this.setState({ month: selectOption?.value })}
                                                            options={this.state.monthOptions}
                                                            placeholder={`Select Month`}
                                                            value={ this.state.month ? this.state.monthOptions.find(option => option.value === this.state.month) : null }/>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-3 position-relative mb-5'>
                                                        <div><label>Status</label></div>
                                                        <div style={{ "zIndex": 9, "width": "90%" }} className=' position-absolute'>
                                                            <Select onChange={(selectedOption) => this.handleSelectChange('selectOption', selectedOption)}
                                                            options={options}
                                                            placeholder={`Select Status`}
                                                            value={this.state.selectOption ? options.find(option => option.value === this.state.selectOption) : null}/>
                                                        </div>
                                                    </div>
                                                    {/* <div className='col-md-6 col-7'>
                                                        <div className="row"> */}
                                                    <div className='col-lg-2 col-md-3 col-6 '>
                                                        <div><label>Apply Filter</label></div>
                                                        {/* <button onClick={this.handleInputSearch}
                                                        className={`btn btn-info btn-label waves-effect waves-light w-100`}
                                                        disabled={!this.state.keyword && !this.state.month && this.state.from_date === '' && this.state.to_date === '' && this.state.selectOption === '' && !this.state.filter_leave_type_id}
                                                        type="button">
                                                            <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                                            Filter
                                                        </button> */}
                                                        <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.setState({loadingFilter: "1"},()=>{this.handleInputSearch()})}} 
                                                        disabled={!this.state.keyword && !this.state.month && this.state.from_date === '' && this.state.to_date === '' && this.state.selectOption === '' && !this.state.filter_leave_type_id}
                                                        loading={this.state.loadingFilter==="1"} loadingMessage='Loading' 
                                                        buttonName={"Filter"}  type='info' icon='ri-filter-3-fill' />
                                                    </div>
                                                    <div className='col-lg-2 col-md-3 col-6'>
                                                        <div><label>Clear Filter</label></div>
                                                        {/* <button onClick={this.handleClearAll}
                                                        className={`w-100 btn btn-secondary btn-label waves-effect waves-light noWrap`}
                                                        disabled={!this.state.keyword && !this.state.month && this.state.from_date === '' && this.state.selectOption === '' && this.state.to_date === '' && !this.state.filter_leave_type_id}
                                                        type="button">
                                                            <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2 "></i>
                                                            Clear
                                                        </button> */}
                                                        <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.setState({loadingFilter: "2"},()=>{this.handleClearAll()})}} 
                                                        disabled={!this.state.keyword && !this.state.month && this.state.from_date === '' && this.state.selectOption === '' && this.state.to_date === '' && !this.state.filter_leave_type_id}
                                                        loading={this.state.loadingFilter==="2"} loadingMessage='Loading' 
                                                        buttonName={"Clear"}  type='secondary' icon='ri-database-2-line' />
                                                    </div>
                                                    { this.state.decodedData?.includes(6) && ( 
                                                    <div className='col-lg-2 col-md-3 col-6'>
                                                        <div><label>Export Excel</label></div>
                                                        {/* <button onClick={this.handleExcelDownload}
                                                        className={`w-100  btn btn-success btn-label waves-effect waves-light noWrap`}
                                                        disabled={this.state.rows.length === 0}
                                                        type="button">
                                                            <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                                            Export Excel
                                                        </button> */}
                                                        <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.handleExcelDownload() }} 
                                                        disabled={this.state.rows.length === 0}
                                                        buttonName={"Export Excel"}  type='success' icon='ri-file-excel-2-line' />
                                                    </div>)}
                                                        {/* </div>
                                                    </div> */}
                                                </div>
                                            </div>
                                            <div ref={this.attendanceLocationInfoRef} className="mt-1" >
                                                {showLocation==="1" && (
                                                    <div className={`${this.state.punch_in_date || this.state.punch_out_date ? '' : 'd-none'} rounded-3 position-relative card-body grayBlurShadow mx-1`}>
                                                        <h6 className={`${this.state.punch_in_date !== null ? '' : 'd-none'} card-title mb-3 d-flex align-items-center mt-md-0 mt-2 me-md-0 me-2`}>
                                                            <span className='bx bx-log-in fs-3' style={{ marginRight: "10px" }} />
                                                            <span>Punch In Date : {this.state.punch_in_date} , Time : {this.state.punch_in_time}</span>
                                                        </h6>
                                                        <h6 className={`${this.state.punch_out_date !== null ? '' : 'd-none'} card-title mb-3 d-flex align-items-center mt-md-0 mt-2 me-md-0 me-2`}>
                                                            <span className='bx bx-log-out fs-3' style={{ marginRight: "10px" }} />
                                                            <span>Punch Out Date : {this.state.punch_out_date} , Time : {this.state.punch_out_time}</span>
                                                        </h6>
                                                        <h6 className={`card-title mb-3 d-flex align-items-center`}>
                                                            <span className='ri ri-map-pin-2-line fs-3' style={{ marginRight: "10px" }}></span>
                                                            <span>{this.state.punch_in_date === null ? (this.state.punch_out_address) : this.state.punch_in_address}</span>
                                                        </h6>
                                                        <span onClick={() => { this.setState({ showLocation: false }) }} style={{ right: "0.2rem", top: "0.2rem", cursor: "pointer" }} className=" position-absolute text-danger"><i className="ri-close-circle-line" style={{ fontSize: '26px' }}/></span>
                                                        {/* <span onClick={() => { this.setState({ showLocation: false }) }} style={{ right: "1rem", top: "1rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span> */}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="col-lg-12 mt-2">
                                                <div>
                                                    <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                                                        <table style={{ width: '110%', minWidth: '1200px' }} className=" position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">
                                                            <thead className='bg-primary text-light bg-gradient sticky-top z-1'>
                                                                <tr className='text-center'>
                                                                    {/* <th className='noWrap'>Sr.No.</th> */}
                                                                    <th className='noWrap'>Date</th>
                                                                    <th className='noWrap'>Punch In</th>
                                                                    <th className='noWrap'>Punch Out</th>
                                                                    <th className='noWrap'>Shift</th>
                                                                    <th className='noWrap'>Working Hours</th>
                                                                    {/* <th className='noWrap'>Deviation</th> */}
                                                                    <th className='noWrap'>Attendance Status</th>
                                                                    <th className='noWrap'>Action</th>
                                                                    {/* <th className='noWrap'>Regularization Status</th>
                                                                    <th className='noWrap'>Regularization Type</th>
                                                                    <th className='noWrap'>Reason</th>
                                                                    <th className='noWrap'>Remark</th> */}
                                                                </tr>
                                                            </thead>
                                                            {this.state.rows.length === 0 ? (
                                                                <tbody>
                                                                    <tr>
                                                                        <td colSpan={12}>
                                                                            <NoRecords />
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            ) : (

                                                                this.state.rows.map((row, idx) => (
                                                                    <tbody className='text-center'>
                                                                        <tr>
                                                                            {/* <td className='text-center noWrap'>{idx + 1}</td> */}
                                                                            <td className='text-center noWrap'>{row.attendance_date ? formatDate(row.attendance_date) : "--"}</td>
                                                                            <td>
                                                                                <div className=" d-flex flex-column gap-0 justify-content-start">
                                                                                    <span className={`${row.punch_in_address && "cursorPointer"} text-info  d-flex justify-content-start`} 
                                                                                    style={{ textDecoration: "underline", }} onClick={() => {
                                                                                        if (row.punch_in_address) {
                                                                                            this.showInMap(row.punch_in_latlng, formatDate(row.PunchIn), formatTime(row.PunchIn), row.punch_in_address, "1");
                                                                                            this.scrollToDiv();
                                                                                        }
                                                                                    }}>
                                                                                        <span className='noWrap'>{formatDate(row.PunchIn)} {formatTime(row.PunchIn)}</span>
                                                                                    </span>
                                                                                    <div style={{ width: "139px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                                        <small>{row.punch_in_address ? row.punch_in_address : row.PunchIn && !row.punch_in_address ? "Location is not captured." : "--"}</small>
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td >
                                                                                <div className=" d-flex flex-column gap-0 justify-content-start">
                                                                                    <span className={`${row.punch_out_address && "cursorPointer"} text-info  d-flex justify-content-start ${!row.PunchOut ? "d-none" : ""}`} 
                                                                                    style={{ textDecoration: "underline",}} onClick={() => {
                                                                                        if (row.punch_out_address) {
                                                                                            this.showOutMap(row.punch_out_latlng, formatDate(row.PunchOut), formatTime(row.PunchOut), row.punch_out_address, "1");
                                                                                            this.scrollToDiv();
                                                                                        }
                                                                                    }}>
                                                                                        <span className=' noWrap'>{formatDate(row.PunchOut)} {formatTime(row.PunchOut)}</span>
                                                                                    </span>
                                                                                    <div style={{ width: "139px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                                        <small>{row.punch_out_address ? row.punch_out_address : row.PunchOut && !row.punch_out_address ? "Location is not captured." : "--"}</small>
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td className='noWrap'>{row.ShiftStart ? convertTo12HourFormat(row.ShiftStart) : "--"} - {row.ShiftEnd ? convertTo12HourFormat(row.ShiftEnd) : "--"}</td>
                                                                            <td className='noWrap'>{row.WorkingHours ? getHoursAndMinutes(row.WorkingHours) : "--"}</td>
                                                                            {/* <td>
                                                                                <span className={isNegativeDeviation(getHoursAndMinutes(row.Deviation)) ? 'text-danger' : ''}>{row.Deviation ? getHoursAndMinutes(row.Deviation) : "--"}</span>
                                                                            </td> */}
                                                                            <td>
                                                                                {row.employee_leave_id ? (
                                                                                    <span className={`badge ${this.checkIsLeave(row) === " / 1" || this.checkIsLeave(row) === " / 2" ? this.calculateWorkingHours(row) ? "bg-warning" : "bg-danger" : "bg-success"}`}>
                                                                                        {this.checkIsLeave(row) === " / 1" || this.checkIsLeave(row) === " / 2"
                                                                                            ? this.calculateWorkingHours(row)
                                                                                                ? "Half Day"
                                                                                                : "Half Day Absent"
                                                                                            : `${row.leave_type_name}`}
                                                                                    </span>
                                                                                ) : row.calendar_festivals_name ? (
                                                                                    <span className="badge bg-secondary">
                                                                                        Holiday
                                                                                    </span>
                                                                                ) : row.ShiftWeekOff === "WeekOff" ? (
                                                                                    <span className={`badge bg-${row.ShiftWeekOffClasses}`}>
                                                                                        {row.ShiftWeekOff}
                                                                                    </span>
                                                                                ) : (
                                                                                    <span className={`badge bg-${row.AttendanceStatusClasses}`}>
                                                                                        {row.AttendanceStatus}
                                                                                    </span>
                                                                                )}
                                                                            </td>
                                                                            <td>
                                                                                {(() => {
                                                                                    const status = this.CheckLeaveAndRegularization(row);
                                                                                    return (
                                                                                        <div className='d-flex align-items-center justify-content-start gap-2'>
                                                                                            {status.Regularization && (
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-sm btn-outline-primary"
                                                                                                    onClick={() => {
                                                                                                        // console.log("row.created_date?.split", currentDateAndTime()?.split(" ")[0] > row.created_date?.split(" ")[0], currentDateAndTime()?.split(" ")[0], row.created_date?.split(" ")[0]);
                                                                                                         this.GetInfo(row);} }>
                                                                                                    Regularize
                                                                                                </button>
                                                                                            )}
                                                                                            {status.RegularizationDetails && (
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-sm btn-info noWrap"
                                                                                                    onClick={() => this.setState({
                                                                                                        employee_id: row.employee_id,
                                                                                                        employee_attendance_id: row.employee_attendance_id,
                                                                                                        attendance_regularization_request_id: row.attendance_regularization_request_id,
                                                                                                        modal_type: 2
                                                                                                    }, (prevState) => this.GetRegularizationLogs())}
                                                                                                >
                                                                                                    Regularize Details
                                                                                                </button>
                                                                                            )}
                                                                                            {status.leaveDetails && (
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-sm btn-info noWrap"                                                                                     
                                                                                                    onClick={() => this.setState({
                                                                                                        employee_id: row.employee_id,
                                                                                                        employee_attendance_id: row.employee_attendance_id,
                                                                                                        attendance_regularization_request_id: row.attendance_regularization_request_id,
                                                                                                        modal_type: 3
                                                                                                    }, (prevState) => this.GetLeaveLogs(row?.employee_leave_id))}
                                                                                                >
                                                                                                    Leave Details
                                                                                                </button>
                                                                                            )}
                                                                                            { row?.multi_punch_data?.length > 0 && (
                                                                                                <IconButton
                                                                                                onClick={() => {this.setState({viewEmployeeVisitLogs: row?.multi_punch_data})}} type='success' 
                                                                                                icon='ri-file-info-line' tooltipName='Logs' tooltipPosition='bottom'/>
                                                                                            ) }
                                                                                            
                                                                                            {/* {status.leave && (
                                                                                                <NavLink to={'/MyLeavesSandBox'}>
                                                                                                    <button type="button" className={`btn btn-sm btn-success ${row.calendar_festivals_name || row.ShiftWeekOff === "WeekOff" ? ('d-none') : ''}`}>
                                                                                                        Leave
                                                                                                    </button>
                                                                                                </NavLink>
                                                                                            )} */}
                                                                                            {!status.Regularization && !status.RegularizationDetails &&
                                                                                                !status.leaveDetails && !status.leave ? "--" : null}
                                                                                        </div>
                                                                                    );
                                                                                })()}
                                                                            </td>
                                                                            {/* <td >{row.regularizationRequestStatus ? <span className={`badge bg-${row.regularizationRequestClasses}`}>{row.regularizationRequestStatus}</span> : "--"}</td>
                                                                            <td >{row.regularizationType ? row.regularizationType : "--"}</td>
                                                                            <td className={` ${row.remark_by_employee?.length > 30 ? "textEllipse" : "noWrap"}`}>{row.remark_by_employee ? row.remark_by_employee : "--"}</td>
                                                                            <td className={` ${row.remark_by_manager?.length > 30 ? "textEllipse" : "noWrap"}`}>{row.remark_by_manager ? row.remark_by_manager : "--"}</td> */}
                                                                        </tr>

                                                                    </tbody>
                                                                ))
                                                            )}
                                                        </table>
                                                    </div>
                                                    {/* <div className="d-flex justify-content-between align-items-center w-100 py-2 px-2" >
                                                        <button disabled={this.state.prev === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                                        <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                            {
                                                                <small>Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}</small>
                                                            }
                                                        </div>
                                                        <div className='col-md-2'>
                                                            <select className="form-select" onChange={(e) => this.handleChange(e)}>
                                                                {Array.from({ length: this.state.total_pages }, (_, i) => (
                                                                    <option selected={this.state.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <select className="form-select" onChange={this.handleLimitChange} value={this.state.limit}>
                                                                {limitOptions.map((option) => (
                                                                    <option key={option} value={option}>
                                                                        Limit {option}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <button disabled={this.state.next === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                                    </div> */}
                                                </div>
                                                {this.state.modal_type && ( 
                                                    <div className="modal show"  style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)",}}>
                                                        {/* <div className={this.state.modal_type === 1 ? `modal-dialog modal-xl` : `modal-dialog modal-xl`}> */}
                                                        <div className={` m-auto mt-3 w-modal`}>
                                                            <div className="modal-content">
                                                                <div className="modal-header">
                                                                    <h5 className="modal-title" id="exampleModalgridLabel">{this.state.modal_type === 1 ? `Regularize Attendance` : this.state.modal_type === 2 ? `Regularization Logs` : `Leave Logs`}</h5>
                                                                    <button type="button" className="btn-close" onClick={()=>{ this.setState({ modal_type:false }) }}  aria-label="Close" />
                                                                </div>
                                                                <div className="modal-body pt-0">
                                                                    {/* { this.state.modal_type === 2 && row.attendance_regularization_request_id} */}
                                                                    {/* <button className="btn btn-outline-danger btn-sm" onClick={() => this.handleCancelRegularization(row.attendance_regularization_request_id)}>
                                                                        <i className='ri-close-fill' style={{ marginTop: "5px" }} /> Cancel
                                                                    </button> */}
                                                                    {this.state.modal_type === 1 &&
                                                                        (<form onSubmit={(e)=> this.handleSubmit(e)}>
                                                                            <div className="row mb-3">
                                                                                <div className="col-md-12">
                                                                                    <p className=' d-flex align-items-center gap-1'><h6 className=' mb-0'>Attendance date:</h6> {this.state.attendance_date? formatDate(this.state.attendance_date):"--"}</p>
                                                                                    <div className='my-3 mx-2'>
                                                                                        <>
                                                                                            <div className="form-check form-check-inline">
                                                                                                <input
                                                                                                    type="radio"
                                                                                                    id="request_type1"
                                                                                                    name="request_type"
                                                                                                    value="1"
                                                                                                    checked={this.state.request_type == '1'}
                                                                                                    onChange={() => this.handleRadioChange('request_type', '1')}
                                                                                                    className="form-check-input"
                                                                                                />
                                                                                                <label htmlFor="request_type1" className="form-check-label">Punch In</label>
                                                                                            </div> <br />
                                                                                        </>
                                                                                        <div className="form-check form-check-inline">
                                                                                            <input
                                                                                                type="radio"
                                                                                                id="request_type2"
                                                                                                name="request_type"
                                                                                                value="2"
                                                                                                checked={this.state.request_type == '2'}
                                                                                                onChange={() => this.handleRadioChange('request_type', '2')}
                                                                                                className="form-check-input"
                                                                                            />
                                                                                            <label htmlFor="request_type2" className="form-check-label">Punch Out</label>
                                                                                        </div>
                                                                                        <br />
                                                                                        <div className="form-check form-check-inline">
                                                                                            <input
                                                                                                type="radio"
                                                                                                id="request_type3"
                                                                                                name="request_type"
                                                                                                value="3"
                                                                                                checked={this.state.request_type == '3'}
                                                                                                onChange={() => this.handleRadioChange('request_type', '3')}
                                                                                                className="form-check-input"
                                                                                            />
                                                                                            <label htmlFor="request_type3" className="form-check-label">Punch In & Punch Out</label>
                                                                                        </div>

                                                                                    </div>
                                                                                </div>
                                                                                <div className='row'>
                                                                                {this.state.request_type == 1 || this.state.request_type == 3 ? (
                                                                                    <div className="col-md-4 ">
                                                                                        <label htmlFor="punch_in_datetime" className="form-label">Punch In DateTime <small className=" text-muted">(24 Hour Format)</small> </label>
                                                                                        <input
                                                                                            type="datetime-local"
                                                                                            id="punch_in_datetime"
                                                                                            name="punch_in_datetime"
                                                                                            className="form-control"
                                                                                            value={this.state.punch_in_datetime}
                                                                                            onChange={this.handleInputChange}
                                                                                            required={true}
                                                                                            step="1" // Allows specifying seconds if needed
                                                                                            pattern="\d{4}-\d{2}-\d{2}T\d{2}:\d{2}" // Ensures 24-hour format
                                                                                        />
                                                                                    </div>) : null}
                                                                                    {/* <strong>{this.state.punch_in_datetime},{this.state.punch_out_datetime}</strong> */}
                                                                                {this.state.request_type == 2 || this.state.request_type == 3 ? (
                                                                                    <div className="col-md-4">
                                                                                        {/* <label htmlFor="punch_out_datetime" className="form-label">Punch Out DateTime</label>
                                                                                        <input
                                                                                            type="datetime-local"
                                                                                            id="punch_out_datetime"
                                                                                            name="punch_out_datetime"
                                                                                            className="form-control"
                                                                                            value={this.state.punch_out_datetime}
                                                                                            onChange={this.handleInputChange}
                                                                                            required={true}
                                                                                        /> */}
                                                                                        <label htmlFor="punch_out_datetime" className="form-label">Punch Out DateTime  <small className=" text-muted">(24 Hour Format)</small></label>
                                                                                            <input
                                                                                                type="datetime-local"
                                                                                                id="punch_out_datetime"
                                                                                                name="punch_out_datetime"
                                                                                                className="form-control"
                                                                                                value={this.state.punch_out_datetime}
                                                                                                onChange={this.handleInputChange}
                                                                                                required={true}
                                                                                                step="1" // Allows specifying seconds if needed
                                                                                                pattern="\d{4}-\d{2}-\d{2}T\d{2}:\d{2}" // Ensures 24-hour format
                                                                                            />
                                                                                    </div>) : null}
                                                                                </div>

                                                                                <div className="col-md-12 mt-3">
                                                                                    <label htmlFor="remark_by_employee" className="form-label">Reason</label>
                                                                                    <textarea
                                                                                        type="text"
                                                                                        id="remark_by_employee"
                                                                                        placeholder="Enter remark"
                                                                                        name="remark_by_employee"
                                                                                        className="form-control"
                                                                                        value={this.state.remark_by_employee}
                                                                                        onChange={this.handleInputChange}
                                                                                        required={true}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className="d-flex justify-content-end">
                                                                                <button type="submit" className="btn btn-success btn-label waves-effect right waves-light">
                                                                                    <i className="bx bx-save label-icon align-middle fs-16 ms-2" /> Send </button>
                                                                            </div>
                                                                        </form>)}
                                                                    {this.state.modal_type === 2 && (
                                                                        <>
                                                                            {this.state.logs_data.length !== 0 ? (
                                                                                <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                                                                                    <table className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">
                                                                                        <thead className='bg-primary text-light bg-gradient'>
                                                                                            <tr>
                                                                                                <th>Action Date</th>
                                                                                                <th>Action By</th>
                                                                                                <th>Requested Punch In</th>
                                                                                                <th>Requested Punch Out</th>
                                                                                                <th>Regularization Type</th>
                                                                                                <th>Reason</th>
                                                                                                <th>Remark</th>
                                                                                                <th>Action Status</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {this.state.logs_data.map((log, idx) => (
                                                                                                <tr key={log.attendance_regularization_request_log_id}>
                                                                                                    <td>{formatDate(log.created_date)}</td>
                                                                                                    <td>{log.employee_name}</td>
                                                                                                    <td>{formatDate(JSON.parse(log.regularization_request_remark).punch_in_datetime) + ' - ' + formatTime(JSON.parse(log.regularization_request_remark).punch_in_datetime)}</td>
                                                                                                    <td>{formatDate(JSON.parse(log.regularization_request_remark).punch_out_datetime) + ' - ' + formatTime(JSON.parse(log.regularization_request_remark)?.punch_out_datetime)}</td>
                                                                                                    <td>{log.regularizationType}</td>
                                                                                                    <td>{JSON.parse(log.regularization_request_remark).remark}</td>
                                                                                                    <td>{log.regularized_by_remark || '---'}</td>
                                                                                                    <td >
                                                                                                        <div className='d-flex flex-wrap justify-content-around align-items-center gap-2'>
                                                                                                            <div className={`badge bg-${log.regularizationRequestClasses}`}>{log.regularizationRequestStatus}</div> 
                                                                                                            {idx === 0 && log?.regularization_request_status == 0 ?
                                                                                                            <button className="btn btn-outline-danger btn-sm mx-2" onClick={() => {this.handleCancelRegularization(log.attendance_regularization_request_id); }}>
                                                                                                                Cancel
                                                                                                            </button> : null}
                                                                                                        </div>
                                                                                                        </td>
                                                                                                </tr>
                                                                                            ))}
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                            ) : (
                                                                                <div>No Logs Found ...!</div>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                    {this.state.modal_type === 3 && (
                                                                        <>
                                                                            {this.state.leave_log_rows?.length > 0 ? (
                                                                                <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                                                                                    <table className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">
                                                                                        <thead className='bg-primary text-light bg-gradient'>
                                                                                            <tr>
                                                                                                <th>Action Date</th>
                                                                                                <th>Action By</th>
                                                                                                <th>Leave Type</th>
                                                                                                <th>From Date</th>
                                                                                                <th>To Date</th>
                                                                                                <th>Total Leave Days</th>
                                                                                                <th>Reason</th>
                                                                                                <th>Remark</th>
                                                                                                <th>Status</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {this.state.leave_log_rows.map(log => (
                                                                                                <tr key={log.attendance_regularization_request_log_id}>
                                                                                                    <td>{formatDate(log.created_date)}</td>
                                                                                                    <td>{log.employee_name}</td>
                                                                                                    <td>{JSON.parse(log.leave_apply_object).leave_type_name}</td>
                                                                                                    <td>{formatDate(JSON.parse(log.leave_apply_object).employee_leave_from_date)}</td>
                                                                                                    <td>{formatDate(JSON.parse(log.leave_apply_object).employee_leave_to_date)}</td>
                                                                                                    <td>{JSON.parse(log.leave_apply_object).employee_leave_days}</td>
                                                                                                    <td className={` ${JSON.parse(log.leave_apply_object).employee_leave_reason?.length >= 30 ? "textEllipse" : "noWrap"} text-start`}>{JSON.parse(log.leave_apply_object).employee_leave_reason || "--"}</td>
                                                                                                    <td className={` ${log.remark?.length >= 30 ? "textEllipse" : "noWrap"} text-start`}>{!log.remark ? "--" : log.remark}</td>
                                                                                                    <td ><span className={`badge bg-${log?.employee_leave_log_status_class}`}>{log?.employee_leave_status_label}</span></td>
                                                                                                </tr>
                                                                                            ))}
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                            ) : (
                                                                                <div>No Logs Found ...!</div>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                       
                                    </div>
                                </div>
                            </div >
                        </div>
                    </div >) : <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
        );
    }
}
export default withRouter(MyAttendance);